import {IValorFleteResponse} from '../modelos/IValorFlete';
import {Observable} from 'rxjs';
import {CommonService} from '../../../shared/utils/common.service';
import {UtilsService} from '../../../shared/utils/utils.service';
import {Injectable} from '@angular/core';
import {moduloGaritas} from '../diccionarios/balanzaModulo.js';

@Injectable({
  providedIn: 'root',
})
export class ParametrizarValorFleteService {
  private diccionarioModulo: any;
  private url: string;
  private urlMaestros: string;

  constructor(private _util: UtilsService, private _commom: CommonService) {
    this.diccionarioModulo = moduloGaritas;
    this.url = this._util.getUrlBascula();
    this.urlMaestros = this._util.getDatosMaestros();
  }

  obtener(): Observable<IValorFleteResponse[]> {
    return this._commom.peticionGetConHeader(
      this.url + this.diccionarioModulo.url.parametrizarValorFlete.obtenerTodo
    );
  }

  obtenerPorId(idValorFlete: number): Observable<IValorFleteResponse> {
    return this._commom.peticionGetConHeader(
      this.url +
      this.diccionarioModulo.url.mantenimientoGaritas.obtenerPorId +
      idValorFlete
    );
  }

  crear(request: any): any {
    return this._commom.peticionPostConHeader(
      this.url + this.diccionarioModulo.url.parametrizarValorFlete.crear,
      request
    );
  }

  actualizar(request: IValorFleteResponse): Observable<any> {
    return this._commom.peticionPutConHeader(
      this.url + this.diccionarioModulo.url.parametrizarValorFlete.actualizar,
      request
    );
  }

  borrar(idValorFlete: number): Observable<any> {
    return this._commom.peticionDeleteConHeader(
      this.url +
      this.diccionarioModulo.url.parametrizarValorFlete.eliminar +
      idValorFlete
    );
  }

  getProveedor(idProveedor: string): Observable<any> {
    return this._commom.peticionGetConHeader(
      (this.url + this.diccionarioModulo.url.proveedor.obtenerPorId + idProveedor)
    );
  }

  getMaterial(idMaterial: string): Observable<any> {
    return this._commom.peticionGetConHeader(
      (this.urlMaestros + this.diccionarioModulo.url.parametrizarValorFlete.getMaterial + idMaterial)
    );
  }

  getAlmacen(idAlmacen: string): Observable<any> {
    return this._commom.peticionGetConHeader(
      (this.url + this.diccionarioModulo.url.parametrizarValorFlete.getAlmacen + idAlmacen)
    );
  }

  obtenerPorProveedorMaterial(proveedor: string, material: string, origen: any): Observable<IValorFleteResponse> {
    let endPoint = this.url + this.diccionarioModulo.url.parametrizarValorFlete.obtenerProveedrorMaterial;
    endPoint = endPoint.concat("proveedor="+proveedor+"&material="+material);

    if(origen != null){ endPoint = endPoint.concat("&origen="+origen); }
    return this._commom.peticionGetConHeader(endPoint);
  }

}
